(() => {
  const guide = {
    ficus: 'care-guide-for-banyan-fig-ficus-microcarpa-bonsai-trees',
    elm: 'chinese-elm-bonsai-ulmus-parvifolia-care-guide',
    privet: 'chinese-privet-ligustrum-sinense-care-guide',
    juniper: 'chinese-juniper-juniper-chinensis-bonsai-tree-care-guide'
  };
  function eligible(species, answers) {
    if (answers.location === 'unknown' || ['dim', 'unknown'].includes(answers.light)) return false;
    if (answers.location === 'warm') return answers.light === 'bright' && ['ficus', 'elm'].includes(species);
    if (answers.location === 'cool') return answers.light === 'bright' && ['elm', 'privet'].includes(species);
    if (answers.location === 'outdoor') return (answers.light === 'sun' && ['juniper', 'elm'].includes(species)) || (answers.light === 'morning' && ['elm', 'privet'].includes(species));
    return false;
  }
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const words = JSON.parse(root.querySelector('[data-words]').textContent);
    const form = root.querySelector('form');
    const steps = [...form.querySelectorAll('[data-step]')];
    const result = root.querySelector('[data-results]');
    const error = root.querySelector('[data-error]');
    const catalog = [...root.querySelectorAll('[data-catalog] article')];
    let step = 0;
    const answers = () => Object.fromEntries(new FormData(form));
    function showStep(focus = true) {
      const indoor = ['warm', 'cool'].includes(answers().location);
      steps[1].querySelectorAll('[data-choice]').forEach(label => {
        const value = label.dataset.choice;
        const hide = indoor ? ['sun', 'morning'].includes(value) : value === 'bright';
        label.hidden = hide;
        label.querySelector('input').disabled = hide;
      });
      steps.forEach((el, i) => { el.hidden = i !== step; });
      root.querySelector('[data-progress]').textContent = `${words.step} ${step + 1} ${words.of} 5`;
      root.querySelector('progress').value = step + 1;
      root.querySelector('[data-next]').textContent = step === 4 ? words.results : words.next;
      root.querySelector('[data-back]').hidden = step === 0;
      error.hidden = true;
      if (focus) steps[step].querySelector('legend').focus();
    }
    function renderResults() {
      const a = answers();
      const cards = root.querySelector('[data-cards]');
      cards.replaceChildren();
      const matched = catalog.filter(card => eligible(card.dataset.species, a) && Number(card.dataset.price) <= Number(a.budget));
      const score = card => {
        let n = 0;
        if (a.experience === 'beginner' && card.dataset.species === 'ficus') n += 4;
        if (a.location === 'outdoor' && a.light === 'sun' && card.dataset.species === 'juniper') n += 3;
        if (a.purpose === 'gift' && card.dataset.gift === 'true') n += 5;
        return n;
      };
      matched.sort((a, b) => score(b) - score(a) || Number(a.dataset.price) - Number(b.dataset.price));
      const chosen = [], counts = {};
      matched.forEach(card => {
        const species = card.dataset.species;
        if ((counts[species] || 0) < 2 && chosen.length < 6) { chosen.push(card); counts[species] = (counts[species] || 0) + 1; }
      });
      chosen.forEach(card => {
        const copy = card.cloneNode(true), species = copy.dataset.species;
        copy.querySelector('[data-why]').textContent = words[`${species}_why`];
        copy.querySelector('[data-note]').textContent = words[`${species}_note`];
        copy.querySelector('[data-care]').href = `/blogs/advice-guides/${guide[species]}`;
        cards.append(copy);
      });
      let message = words.result_intro;
      if (a.location === 'unknown' || a.light === 'unknown') message = words.unknown;
      else if (a.light === 'dim') message = words.low_light;
      else if (!chosen.length) message = words.none_budget;
      root.querySelector('[data-result-heading]').textContent = chosen.length ? words.result_title : words.no_match;
      root.querySelector('[data-result-message]').textContent = message;
      root.querySelector('[data-person-note]').textContent = a.purpose === 'gift' ? words.gift_note : a.experience === 'experienced' ? words.experienced_note : words.routine;
      form.hidden = true; result.hidden = false;
      root.querySelector('[data-result-heading]').focus();
    }
    form.addEventListener('submit', event => {
      event.preventDefault();
      if (!steps[step].querySelector('input:checked:not(:disabled)')) {
        error.hidden = false; steps[step].querySelector('input:not(:disabled)').focus(); return;
      }
      if (step === 4) renderResults(); else { step++; showStep(); }
    });
    form.addEventListener('change', event => {
      error.hidden = true;
      if (event.target.name === 'location') steps[1].querySelectorAll('input').forEach(input => { input.checked = false; });
    });
    root.querySelector('[data-back]').addEventListener('click', () => { step = Math.max(0, step - 1); showStep(); });
    root.querySelector('[data-change]').addEventListener('click', () => { result.hidden = true; form.hidden = false; step = 0; showStep(); });
    root.querySelector('[data-restart]').addEventListener('click', () => { form.reset(); result.hidden = true; form.hidden = false; step = 0; showStep(); });
    showStep(false);
  }
  document.querySelectorAll('[data-bonsai-finder]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-bonsai-finder]').forEach(init));
})();
